import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { PreferredTimePopupModal } from "./PreferredTimePopupModal.js";
const PreferredTimePopupModalContainer = ({ items, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("appointments.component.preferredTimePopupModal.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(PreferredTimePopupModal, { ...rest, labels, items });
};
export {
  PreferredTimePopupModalContainer,
  PreferredTimePopupModalContainer as default
};
//# sourceMappingURL=PreferredTimePopupModalContainer.js.map
